import * as angular from "angular";
import { CountryDataProvider } from "../../data-provider/country.dp";
import { ApiUserService } from "../../services/user.service";

let PhoneLoginComponent = {
    selector: "vcPhoneLogin",
    templateUrl: "/angular/components/login/phone-login.component.html",
    bindings: {
        loginObj: "=?",
        loginType: "=?",
        cancelFn: "&?",
        successFn: "&?",
    },
    controller: class PhoneLoginController {
        // * bindings for typescript compiler *
        public cancelFn?: any;
        public successFn?: any;
        // ************************************

        private readonly $scope: any;
        private readonly __time_zone: string;

        private __env: any;
        private $http: any;
        private apiUserService: ApiUserService;

        public loading = false;
        public error: string;
        public login: any;

        public countryDataProvider: CountryDataProvider;
        public loginObj: any;
        public loginType: string;
        public view = "phone";

        constructor(
            $scope: any,
            __env: any,
            $http: any,
            __time_zone: string,
            ApiUserService: ApiUserService,
            CountryDataProvider: CountryDataProvider
        ) {
            this.$scope = $scope;
            this.$http = $http;
            this.__env = __env;
            this.__time_zone = __time_zone;
            this.apiUserService = ApiUserService;
            this.countryDataProvider = CountryDataProvider;

            this.apiUserService.country().then((response: object) => {
                const json = response["data"];
                if (json.success) {
                    this.loginObj.selectedCountry =
                        this.countryDataProvider.getCountryFromCode(
                            json.country
                        );
                }
            });

            this.$scope.$watch(
                () => this.loginObj,
                (newValue: string | null, oldValue: string | null) => {
                    if (
                        newValue !== oldValue &&
                        newValue["code"] &&
                        newValue["code"].length == 6
                    ) {
                        this.phoneVerifySubmit();
                    }
                },
                true
            );
        }

        submitPhoneNumber(): void {
            this.loading = true;
            this.error = null;
            this.loginType = "phone";

            let data = {
                phonenumber: this.loginObj.phonenumber,
                countrycode: this.loginObj.countrycode.substring(1),
            };
            this.$http
                .post(
                    this.getUrlBase() +
                        "/verification/phoneauthenticate?timezone=" +
                        encodeURIComponent(this.__time_zone),
                    data
                )
                .then(
                    (response: object) => {
                        if (response["data"].data) {
                            this.view = "verify";
                        } else {
                            this.error =
                                "Sorry, we cannot find a user account associated with that phone number";
                        }
                        this.loading = false;
                    },
                    () => {
                        this.error = "An error has occurred";
                        this.loading = false;
                    }
                );
        }

        phoneVerifySubmit(): void {
            this.loading = true;
            let data = {
                phonenumber: this.loginObj.phonenumber,
                countrycode: this.loginObj.countrycode.substring(1),
                code: this.loginObj.code,
                dashboard: true,
            };
            this.$http
                .post(
                    this.getUrlBase() +
                        "/login/phonenumber?timezone=" +
                        encodeURIComponent(this.__time_zone),
                    data
                )
                .then(
                    (response: object) => {
                        if (response["data"] && response["data"]["errors"]) {
                            this.loading = false;
                            if (response["data"]["errors"]["detail"]) {
                                this.error =
                                    response["data"]["errors"]["detail"];
                            } else {
                                this.error = "An error has occurred";
                            }
                        } else {
                            this.successFn({ response: response });
                        }
                    },
                    () => {
                        this.error = "An error has occurred";
                        this.loading = false;
                    }
                );
        }

        getUrlBase(region?: string): string {
            let url = this.__env.apiUrl();
            if (region) {
                url =
                    "https://" +
                    region +
                    "." +
                    this.__env.host +
                    this.__env.apiUrl();
            }
            return url;
        }
    },
};

angular
    .module("login", [])
    .component(PhoneLoginComponent.selector, PhoneLoginComponent);
